// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__dzxqm","validationTips":"StatementDescriptor_validationTips__2dRfw"};